export const mutations = {
  AGENCY_FETCH_SHOP_LIST: "AGENCY_FETCH_SHOP_LIST",
  AGENCY_UPDATE_SHOP_PAGINATION: "AGENCY_UPDATE_SHOP_PAGINATION",
  AGENCY_UPDATE_AGENCY_INFO: "AGENCY_UPDATE_AGENCY_INFO",
  AGENCY_UNLINK_SHOP: "AGENCY_UNLINK_SHOP",
  AGENCY_UPDATE_FETCHED: "AGENCY_UPDATE_FETCHED",
  AGENCY_CHANGE_SEARCH: "AGENCY_CHANGE_SEARCH",
  AGENCY_UPDATE_STATUS: "AGENCY_UPDATE_STATUS"
};

export const actions = {
  FETCH_SHOP_LIST_AGENCY: "fetchShopList",
  UPDATE_SHOP_PAGINATION_AGENCY: "updateShopPagination",
  LOGIN_SHOP_AGENCY: "loginShop",
  LOGIN_SHOP_FROM_AGENCY: "loginShopFromAgency",
  GET_AGENCY: "getAgency",
  ADD_SHOP_AGENCY: "addShop",
  UNLINK_SHOP_AGENCY: "unlinkShop",
  UPDATE_AGENCY_INFO_AGENCY: "updateAgencyInfo",
  UPDATE_AGENCY_PASSWORD_AGENCY: "updateAgencyPassword",
  SIGN_OUT_AGENCY: "signoutAgency",
  CHECK_LINKED_AGENCY: "checkLinkedAgency",
  UPLOAD_IMAGE_AGENCY: "uploadImage",
  OPEN_SWITCH_AGENCY_MODAL: "openSwitchAgencyModal",
  CLOSE_SWITCH_AGENCY_MODAL: "closeSwitchAgencyModal"
};
